var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [_vm._v("Access Request")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Role")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _vm._m(2),
            _vm._v(" "),
            _c("td", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.ROLE_CD,
                      expression: "formData.ROLE_CD"
                    }
                  ],
                  ref: "userRole",
                  staticClass: "slt_white input-58",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData,
                        "ROLE_CD",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.availableUserRoleList, function(item) {
                  return _c(
                    "option",
                    { key: item.CODE_ID, domProps: { value: item.CODE_ID } },
                    [_vm._v(_vm._s(item.CODE_NAME))]
                  )
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap topLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit mt40" }, [_vm._v("Basic")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _vm._m(4),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.NAME,
                      expression: "formData.NAME"
                    },
                    { name: "validation", rawName: "v-validation" },
                    { name: "clearable", rawName: "v-clearable" }
                  ],
                  ref: "name",
                  staticClass: "text_input w100",
                  attrs: {
                    type: "text",
                    placeholder: "",
                    maxlength: "25",
                    minlength: "2"
                  },
                  domProps: { value: _vm.formData.NAME },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "NAME", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.ENAME,
                      expression: "formData.ENAME"
                    },
                    { name: "validation", rawName: "v-validation" },
                    {
                      name: "regex",
                      rawName: "v-regex",
                      value: "/[^a-zA-Z., ]/g",
                      expression: "'/[^a-zA-Z., ]/g'"
                    },
                    { name: "clearable", rawName: "v-clearable" }
                  ],
                  ref: "ename",
                  staticClass: "text_input w100",
                  attrs: {
                    type: "text",
                    placeholder: "",
                    maxlength: "25",
                    minlength: "2"
                  },
                  domProps: { value: _vm.formData.ENAME },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "ENAME", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          !["", "A02", "A03", "S01", "S02"].includes(_vm.formData.ROLE_CD)
            ? _c("tr", { key: _vm.formData.ROLE_CD }, [
                _c("th", [
                  _vm._v("\n                            ESN/IMEI Writing P/W "),
                  _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("em", { staticClass: "ico_info" }, [
                    _c("i", {
                      staticClass: "tooltip",
                      domProps: {
                        innerHTML: _vm._s(_vm.getImeiPasswordRulesText())
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.IMEI_PASS,
                          expression: "formData.IMEI_PASS"
                        },
                        { name: "validation", rawName: "v-validation" },
                        { name: "clearable", rawName: "v-clearable" }
                      ],
                      ref: "imei_pass",
                      staticClass: "text_input w100",
                      attrs: {
                        type: "password",
                        placeholder: "",
                        minlength: "10",
                        maxlength: "20"
                      },
                      domProps: { value: _vm.formData.IMEI_PASS },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "IMEI_PASS",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.IMEI_PASS_CONF,
                          expression: "formData.IMEI_PASS_CONF"
                        },
                        { name: "validation", rawName: "v-validation" },
                        { name: "clearable", rawName: "v-clearable" }
                      ],
                      ref: "imei_pass_conf",
                      staticClass: "text_input w100",
                      attrs: {
                        type: "password",
                        placeholder: "",
                        minlength: "10",
                        maxlength: "25"
                      },
                      domProps: { value: _vm.formData.IMEI_PASS_CONF },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "IMEI_PASS_CONF",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _vm._m(7),
            _vm._v(" "),
            _c("td", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.COUNTRY_CD,
                      expression: "formData.COUNTRY_CD"
                    }
                  ],
                  ref: "country",
                  staticClass: "slt_white w100p",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData,
                        "COUNTRY_CD",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.availableCountryList, function(item) {
                  return _c(
                    "option",
                    { key: item.CODE_ID, domProps: { value: item.CODE_ID } },
                    [_vm._v(_vm._s(item.CODE_NAME))]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("E-Mail")]),
            _vm._v(" "),
            _c("td", [
              _c("span", { staticClass: "clearable" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.EMAIL,
                      expression: "formData.EMAIL"
                    },
                    {
                      name: "regex",
                      rawName: "v-regex",
                      value: "/[^0-9a-z-_+@.#$]/gi",
                      expression: "'/[^0-9a-z\\-_+@.#$]/gi'"
                    },
                    { name: "validation", rawName: "v-validation" }
                  ],
                  ref: "email",
                  staticClass: "text_input w100",
                  attrs: {
                    type: "text",
                    placeholder: "",
                    readonly: "",
                    maxlength: "100"
                  },
                  domProps: { value: _vm.formData.EMAIL },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "EMAIL", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }, [
        _c("div", { staticClass: "btn_right" }, [
          _c(
            "a",
            {
              staticClass: "btn_blue",
              attrs: { title: "" },
              on: { click: _vm.onRequestButtonClick }
            },
            [_vm._v("Request")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n                Home\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Engineer\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile SVC\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Access Request\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("User Role "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Name "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("English Name "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("ESN/IMEI Confirm P/W "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Country "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7399f94b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7399f94b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/request/RequestCert.vue
// module id = nBs5
// module chunks = 0